var hasPermission = require('../methods/has-permission');

module.exports = function(h) {
    return right => {
        var sortControl = require('vue-tables-2/compiled/modules/sort-control')(
            h,
            right,
        );

        var headings = [];
        const permission =
            typeof this.opts.permission.delete === 'function'
                ? this.opts.permission.delete()
                : this.opts.permission.delete;

        if (this.opts.checkbox && hasPermission.call(this, permission)) {
            headings.push(<vuetable2-heading table-instance={this} />);
        }

        if (this.hasChildRow && this.opts.childRowTogglerFirst)
            headings.push(<th />);

        this.allColumns.map(
            function(column) {
                headings.push(
                    <th
                        on-click={this.orderByColumn.bind(this, column)}
                        class={this.sortableClass(column)}
                    >
                        <span
                            class="VueTables__heading"
                            title={this.getHeadingTooltip(column, h)}
                        >
                            {this.getHeading(column, h)}
                        </span>
                        {sortControl.call(this, column)}
                    </th>,
                );
            }.bind(this),
        );

        if (this.hasChildRow && !this.opts.childRowTogglerFirst)
            headings.push(<th />);

        return headings;
    };
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/modules/headings.jsx